/* ══════════════════════════════════════════════════════════════
   India Master Configuration
   Central configuration object for all India-specific settings
   ══════════════════════════════════════════════════════════════ */

export const INDIA_CONFIG = {
    country: 'IN',
    countryName: 'India',
    currency: 'INR',
    currencySymbol: '₹',
    numberSystem: 'indian' as const,
    timezone: 'Asia/Kolkata',
    locale: 'en-IN',

    /** Market trading hours (IST) */
    marketHours: {
        preOpen: { start: '09:00', end: '09:15' },
        trading: { start: '09:15', end: '15:30' },
        postClose: { start: '15:40', end: '16:00' },
        mcx: { start: '09:00', end: '23:30' },
    },

    /** Weekend + fixed holidays (updated annually) */
    holidays2026: [
        '2026-01-26', // Republic Day
        '2026-03-10', // Maha Shivaratri
        '2026-03-17', // Holi
        '2026-04-02', // Ugadi / Gudi Padwa
        '2026-04-14', // Dr. Ambedkar Jayanti
        '2026-04-18', // Good Friday
        '2026-04-21', // Ram Navami
        '2026-05-01', // Maharashtra Day
        '2026-05-25', // Buddha Purnima
        '2026-07-07', // Eid ul-Adha
        '2026-08-15', // Independence Day
        '2026-08-16', // Parsi New Year
        '2026-10-02', // Mahatma Gandhi Jayanti
        '2026-10-20', // Dussehra
        '2026-11-09', // Diwali (Laxmi Pujan)
        '2026-11-10', // Diwali (Balipratipada)
        '2026-11-27', // Guru Nanak Jayanti
        '2026-12-25', // Christmas
    ],

    /** Primary exchanges */
    exchanges: {
        nse: {
            name: 'National Stock Exchange',
            shortName: 'NSE',
            baseUrl: 'https://www.nseindia.com',
            apiBase: 'https://www.nseindia.com/api',
        },
        bse: {
            name: 'Bombay Stock Exchange',
            shortName: 'BSE',
            baseUrl: 'https://www.bseindia.com',
            apiBase: 'https://api.bseindia.com/BseIndiaAPI/api',
        },
        mcx: {
            name: 'Multi Commodity Exchange',
            shortName: 'MCX',
            baseUrl: 'https://www.mcxindia.com',
        },
    },

    /** Regulatory bodies */
    regulators: {
        rbi: { name: 'Reserve Bank of India', apiBase: 'https://data.rbi.org.in/DBIE' },
        sebi: { name: 'Securities and Exchange Board of India' },
        amfi: { name: 'Association of Mutual Funds in India', apiBase: 'https://www.amfiindia.com' },
    },

    /** Cache TTLs (seconds) */
    cacheTTL: {
        indices: 30,
        optionsChain: 60,
        fiiDii: 3600,
        marketBreadth: 30,
        commodities: 60,
        currency: 60,
        news: 300,
        aiSummary: 7200,
        classification: 86400,
        earnings: 3600,
        ipo: 300,
        rbiPolicy: 3600,
        stateGdp: 86400,
    },

    /** API rate limits */
    rateLimits: {
        nse: { perMinute: 50, sessionRotation: 300000 },
        groq: { perDay: 14400 },
        openrouter: { perDay: 50 },
        finnhub: { perMinute: 60 },
    },
} as const;

export type IndiaConfig = typeof INDIA_CONFIG;
